import { TranslatedField } from '@pages/roboto-calls/utils/models/speech-kit-fields';
import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';

export function useGetCallFields(type: 'LEAD' | 'DEBT') {
  return useQuery<TranslatedField[]>({
    queryKey: ['call-fields', type],
    queryFn: async () => {
      const res = await $api.get(`/v1/robot-call/calls/fields/${type}`);

      return res.data.data;
    },
    enabled: !!type
  });
}
